import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-row mr-auto" }
const _hoisted_3 = { class: "max-w-lg w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_10 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateTimeSelector from "@/components/tools/DateTimeSelector.vue";
import DateSelector from "@/components/tools/DateSelector.vue";
import AffiliateDetailTableDialog from "@/components/dialogs/AffiliateDetailTableDialog.vue";
import DropdownComponent from "@/components/tools/DropdownComponent.vue";
import { formatNumber } from "@/utils/tools";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const months: any = ref([]);
const startDate = dayjs();
const beginningDate = "2023-01-01";
const diff = startDate.diff(beginningDate, "months");
const router = useRouter();
const selectedOption = ref({
  label: dayjs().startOf("month").format("MM/YYYY"),
  value: dayjs().endOf("month").format("YYYY-MM-DD"),
});
// const dateSelectorRef = ref(null);
const searchDate = ref({
  from: route.query.from || dayjs().startOf("month").format("YYYY-MM-DD"),
  to: route.query.to || dayjs().endOf("month").format("YYYY-MM-DD"),
});

for (let i = 0; i <= diff; i++) {
  months.value.push({
    label: dayjs(beginningDate).add(i, "month").format("MM/YYYY"),
    value: dayjs(beginningDate).add(i, "month").format(),
  });
}
// months.value.push({
//   label: "Yesterday",
//   value: dayjs().add(-1, "day").format(),
// });

const onMonthChange = (data: any) => {
  selectedOption.value = data;
  filterByMonth(data);
};

const columns = ref([
  {
    label: "Username",
    field: "username",
    align: "center",
    format: (data: any) => (data.username ? data.username : "-"),
  },
  {
    label: "Affiliate Bet Amount",
    field: "total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.bet_amount),
    class: (data: any) =>
      Number(data.bet_amount) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: "Affiliate Amount",
    field: "total",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.affiliate_amount),
    class: (data: any) =>
      Number(
        data.affiliate_amount
      ) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: "",
    field: "summaries_data",
    isRow: true,
    isButton: true,
    buttonTitle: "View Details",
    format: (data: any) => data,
  },
]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: ["created_at", "DESC"],
});
const filterForm = ref({
  username: null,
  channel: null,
  moduleCode: null,
  from: null,
  to: null,
});
const dataRow = ref();
const showDialog = (data: any) => {
  // dataRow.value = data;
  dataRow.value = data.downline_details;
  advanceFilterModal.value = true;
};

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};
const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[1];
  if (attName === "Requested Date") attName = "created_at";
  if (attName === "Affiliate Bet Amount") attName = "bet_amount";

  pageConfig.value.sort = [
    attName.toLowerCase().replace(" ", "_"),
    mode === "DESC" ? "ASC" : "DESC",
  ];

  fetchPageData();
};
const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;
  const formInput = filterForm.value;
  if(formInput.from) { searchDate.value.from = formInput.from }
  if(formInput.to) { searchDate.value.to = formInput.to }
  const from = searchDate.value.from;
  const to = searchDate.value.to;

  // let sort = [['created_at', 'DESC']]
  // let sort = sortBy.value.length ? sortBy.value : [['created_at', 'DESC']];
  let offset = page * rowsPerPage - rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
  }

  const search = pageConfig.value.search || route.query.search

  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    offset: offset,
    limit: rowsPerPage,
    search: search,
    start_date: from,
    end_date: to,
    sort_by: sort,
    // phone_number: phone,
    // search: searchInput.value,
  };
  // if (!phone_number) delete payload.phone_number;
  // if (!search) delete payload.search;

  const url = `${process.env.VUE_APP_API_ENDPOINT}/cms/monthly-carry-forward`;
  const rows = await axios
    .post(url, payload)
    .then(({ data }) => (data.filter((x: any) => x)));

  // if(!rows || rows.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  const count = 0
  pageConfig.value.dataLength = rows.length;

  dataRows.value = rows;

  pageConfig.value = {
    ...pageConfig.value,
    count,
    pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  const queryParams: any = { page, rowsPerPage }
  if(from) { queryParams.from = from}
  if(to) { queryParams.to = to}
  if(search) { queryParams.search = search}
  window.history.replaceState(
    {},
    document.title,
    `affiliate-summary-carry-forward?${stringify(queryParams)}`
  );
  // (dateSelectorRef.value as any).state = {
  //   from,
  //   to
  // };
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  isLoaded.value = false;
  pageConfig.value.page = 1;
  fetchPageData();
};

const filterByMonth = (payload: any) => {
  let from: any = dayjs(payload.value).startOf("month").format("YYYY-MM-DD");
  let to: any = dayjs(payload.value).endOf("month").format("YYYY-MM-DD");
  // if (payload.label == "Yesterday") {
  //   from = dayjs(payload.value)
  //     .hour(0)
  //     .minute(0)
  //     .second(0)
  //     .format("YYYY-MM-DD");
  //   to = dayjs(payload.value)
  //     .hour(23)
  //     .minute(59)
  //     .second(59)
  //     .format("YYYY-MM-DD");
  // }

  // (dateSelectorRef.value as any).state = {
  //   from: dayjs(from).format("YYYY-MM-DDThh:mm"),
  //   to: dayjs(to).format("YYYY-MM-DDThh:mm"),
  // };

  isLoaded.value = false;
  filterForm.value.from = from;
  filterForm.value.to = to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.affiliateSummary.affiliateSummaryCarryForward')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData(true))),
              maxlength: "10",
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: "Search...",
              type: "search",
              name: "search"
            }, null, 544), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(DropdownComponent, {
            modelValue: selectedOption.value,
            options: months.value,
            onOnOptionSelected: onMonthChange
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onShowDetailTable: showDialog,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(AffiliateDetailTableDialog, {
      class: "z-10 w-full",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((advanceFilterModal).value = $event)),
      dataRows: dataRow.value
    }, null, 8, ["show", "dataRows"])
  ]))
}
}

})